<template>
    <div class="computerBox">
        <topBox :title="$route.meta.title" />
        <div class="px-[36px] w-full mt-[80px] pb-[70px]">

            <div class="my-3">
                <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('revision.currentPassword') }}</h1>
                <input
                    type="password"
                    class="block w-full px-[35px] py-[15px] border rounded-full bg-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1 focus:outline-none text-ms"
                    :placeholder="$t('revision.currentPassword')"
                    v-model="input.pass_pay"
                />
                <p class="mt-2 text-14 text-slate-400 text-right px-2">{{ $t('placeholder.firstSettingFund') }}</p>
            </div>

            <div class="my-3">
                <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('revision.aNewPassword') }}</h1>
                <input
                    type="password"
                    class="block w-full px-[35px] py-[15px] border rounded-full bg-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1 focus:outline-none text-ms"
                    :placeholder="$t('revision.aNewPassword')"
                    v-model="input.new"
                />
            </div>

            <div class="my-3">
                <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('revision.confirmYourPassword') }}</h1>
                <input
                    type="password"
                    class="block w-full px-[35px] py-[15px] border rounded-full bg-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1 focus:outline-none text-ms"
                    :placeholder="$t('revision.confirmYourPassword')"
                    v-model="input.confirm"
                />
            </div>

            <div class="mt-6 py-[10px]">
                <button
                    type="button"
                    class="block w-full px-5 py-[15px] border rounded-full butSubmit text-white shadow-lg focus:ring-1 focus:outline-none text-xs-xs"
                    @click="onSubmit"
                >
                    {{ $t('but.continue') }}
                </button>
            </div>

        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'
import axios from 'axios'
import { layer } from 'vue3-layer'

export default {
    components: {
        topBox,
        mainMenu,
    },
    data() {
        return {
            lang: '',
            input: {
                pass_pay: '',
                new: '',
                confirm: '',
            },
        }
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang
    },
    methods: {
        onSubmit() {
            axios.post(
                '/api/m/edit/fund',
                {
                    pass_pay: this.input.pass_pay,
                    new: this.input.new,
                    confirm: this.input.confirm,
                },
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        token: localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                if (response.data.code === 0) {
                    layer.msg(response.data.msg)
                    this.input.pass_pay = ''
                    this.input.new = ''
                    this.input.confirm = ''
                } else if (response.data.data && response.data.data.id) {
                    layer.msg(this.$t('input.' + response.data.data.id) + ' ' + response.data.msg)
                } else {
                    layer.msg(response.data.msg)
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.computerBox {
    /* background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat; */
}
</style>
